export const GITHUB = 'github';
export const GITLAB = 'gitlab';
export type GitPlatform = typeof GITHUB | typeof GITLAB | null;
